var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    slot: "header"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItem), function(item, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(item.children.length > 0) ? [_c('SidebarNavDropdown', {
      attrs: {
        "name": item.name,
        "url": item.url,
        "icon": item.icons
      }
    }, [_vm._l((item.children), function(child) {
      return [(child.children.length > 0) ? [_c('SidebarNavDropdown', {
        staticClass: "nestedClass",
        attrs: {
          "name": child.name,
          "icon": child.icons
        }
      }, [_vm._l((child.children), function(childInChild) {
        return [(childInChild.children.length > 0) ? [_c('SidebarNavDropdown', {
          staticClass: "nestedSub-links",
          attrs: {
            "name": childInChild.name,
            "url": childInChild.url,
            "icon": childInChild.icons
          }
        }, [_vm._l((childInChild.children), function(nestedInChild) {
          return [(nestedInChild.ismenu == true) ? _c('SidebarNavLink', {
            attrs: {
              "name": nestedInChild.name,
              "url": nestedInChild.url,
              "icon": nestedInChild.icons
            },
            on: {
              "click": function($event) {
                _vm.test()
              }
            }
          }) : _vm._e()]
        })], 2)] : [(childInChild.ismenu == true) ? _c('SidebarNavLink', {
          attrs: {
            "name": childInChild.name,
            "url": childInChild.url,
            "icon": childInChild.icons
          },
          on: {
            "click": function($event) {
              _vm.test()
            }
          }
        }) : _vm._e()]]
      })], 2)] : [(child.ismenu == true) ? _c('SidebarNavLink', {
        staticClass: "aa",
        attrs: {
          "name": child.name,
          "icon": child.icons,
          "url": child.url
        }
      }) : _vm._e()]]
    })], 2)] : [(item.ismenu == true) ? _c('SidebarNavLink', {
      attrs: {
        "name": item.name,
        "icon": item.icons,
        "url": item.url
      }
    }) : _vm._e()]], 2)
  })), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    slot: "footer"
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cbd20a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 358
// module chunks = 1